import * as cl from "classnames"
import * as React from "react"

export default class ServerAddressField extends React.Component<Props> {
	static id = "local-authority-detail-bl-server-addres"

	render() {
		const className = cl("input is-fullwidth", { "is-loading": this.props.loading })

		return <div className="field">
		<label className="label" htmlFor={ServerAddressField.id}>
			Adresse du serveur
		</label>

		<span className="control">
			<input
			className={className}
			disabled={this.props.loading}
			id={ServerAddressField.id}
			placeholder="192.168.0.0"
			required
			type="text"
			value={this.props.value || ""}
			onChange={e => this.props.onChange(e.target.value)}/>
		</span>
	</div>
	}
}

interface Props {
	loading: boolean;
	value: string | null;
	onChange(value: string): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/connector-field/berger-levrault-connector/server-address-field.tsx